'use strict';

exports.__esModule = true;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _headHelmet = require('../../../head-helmet');

var _footer = require('../../../footer');

var _style = require('../../src/styles/style.scss');

var _style2 = _interopRequireDefault(_style);

var _logoDark = require('../../src/assets/logo-dark.svg');

var _logoDark2 = _interopRequireDefault(_logoDark);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var BasicText = function BasicText(props) {
	return _react2.default.createElement(
		'div',
		null,
		_react2.default.createElement(_headHelmet.HeadHelmet, {
			pageTitle: props.pageTitle,
			pageContent: props.pageContent,
			pageImage: props.profileImage || _logoDark2.default,
			pagePath: props.pagePath
		}),
		_react2.default.createElement(
			'div',
			{ className: '' + _style2.default.basicTextPage },
			_react2.default.createElement(
				'div',
				{ className: 'site-content -small-page-top' },
				_react2.default.createElement(
					'div',
					{ className: 'container content' },
					props.children || null
				)
			)
		),
		_react2.default.createElement(_footer.Footer, null)
	);
};

BasicText.propTypes = {
	pageTitle: require('react').PropTypes.any,
	profileImage: require('react').PropTypes.any,
	pagePath: require('react').PropTypes.any,
	pageContent: require('react').PropTypes.any
};
BasicText.displayName = 'BasicText';

BasicText.defaultProps = {};

exports.default = BasicText;


// WEBPACK FOOTER //
// ./components/info-page/lib/components/basic-text-page.js